import { SVGProps } from "react";

const IconTransfer = (props: SVGProps<SVGSVGElement>) => (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18.4518 18.9083L23.3498 14.1221L12.2277 3L3.32997 11.8977L10.1941 18.9083" stroke="#333030" strokeWidth="2" strokeLinecap="round" />
        <path d="M11.6715 4.66797L12.7837 13.5657L21.6814 14.6779" stroke="#333030" strokeWidth="2" strokeLinecap="square" />
        <path d="M1.5 19H23.5" stroke="#333030" strokeWidth="2" strokeLinecap="round" />
    </svg>
);

export default IconTransfer;
